"use strict";

export var SideDrawerConstants = {
  SIDE_DRAWER_LIST_LOADED: 'SIDE_DRAWER_LIST_LOADED'
};